import { Rooms, Bathrooms, OtherWindow, Important } from "../../../components";
import { normalizeAddress } from "../../../config/helpers.config";

function toDMS(coord) {
  const absolute = Math.abs(coord);
  const degrees = Math.floor(absolute);
  const minutesNotTruncated = (absolute - degrees) * 60;
  const minutes = Math.floor(minutesNotTruncated);
  const seconds = ((minutesNotTruncated - minutes) * 60).toFixed(1);

  return degrees + "\u00b0" + minutes + "'" + seconds + '"';
}

function formatLatLon(lat, lon) {
  const latitude = toDMS(lat);
  const longitude = toDMS(lon);

  const latitudeHemisphere = lat >= 0 ? "N" : "S";
  const longitudeHemisphere = lon >= 0 ? "E" : "W";

  return latitude + latitudeHemisphere + " " + longitude + longitudeHemisphere;
}

const formatter = new Intl.NumberFormat("es-ES", {
  // minimumFractionDigits: 4,
  maximumFractionDigits: 4,
  // You can specify the separators explicitly
  // For example, to use dots for thousands and commas for decimals
  // Change these separators based on your preference
  useGrouping: true, // Enables the use of a separator for thousands
  // Change these separators based on your preference
  // Here, dots are used for thousands separator and commas for decimals
  // Change according to your desired format
  groupingSeparator: ".",
  decimalSeparator: ".",
});

const Module1 = (props) => {
  const dms = formatLatLon(props.lat, props.lon);
  return (
    <>
      {/* Module 1 */}
      <article className="flex laptop:flex-row flex-col w-full h-full items-center bg-[#F7F7F7]">
        <div className="valuation-parent-container">
          <div className="w-full space-y-3 py-5">
            <h1 className="text-[#262626] text-3xl">
              Tu valoración está lista
            </h1>
            <div className="w-full space-y-5">
              <p className="text-[#656565]">{props.property_type}</p>
              <h2 className="text-4xl font-bold">
                {normalizeAddress(props.address)}
              </h2>
              <ul className="flex flex-wrap text-[#3E3E3E]">
                <li className="mr-4 text-lg font-bold">{props.area} m2</li>
                <li className="mr-4 text-lg font-bold">
                  {props.floor}ª planta
                </li>
                <li className="mr-4">
                  <span className="flex items-center space-x-1 text-lg font-bold">
                    <Rooms />
                    <p>{props.rooms} habs.</p>
                  </span>
                </li>
                <li className="mr-4">
                  <span className="flex items-center space-x-1 text-lg font-bold">
                    <Bathrooms />
                    <p>{props.nbaths} baños</p>
                  </span>
                </li>
              </ul>
              <span className="flex flex-wrap items-center text-lg font-bold">
                <p className="text-[#3E3E3E] font-bold mr-1">
                  Referencia catastral:
                </p>
                <p className="text-[#7E7E7E]">
                  {props.cadastral_ref !== "null"
                    ? props.cadastral_ref
                    : "Sin referencia catastral"}
                </p>
              </span>
            </div>
            <a
              // Google Maps
              href={`https://www.google.com/maps/place/${dms}/@${props.lat},${props.lon},17z`}
              target="_blank"
              rel="noreferrer"
            >
              <span className="flex items-center space-x-1">
                <p className="text-[#2C2C2C]">Ver en Google Maps</p>
                <OtherWindow />
              </span>
            </a>
          </div>
          <div className="flex flex-col w-full h-full justify-between space-y-5">
            <div className="flex laptop:flex-row flex-col w-full justify-between laptop:space-x-6 laptop:space-y-0 space-y-5">
              <div className="bg-white w-full px-7 py-5 rounded-lg space-y-3">
                <div>
                  <p className="text-[#3E3E3E] font-bold text-lg">
                    Precio venta
                  </p>
                  <p className="text-[#222222] font-bold text-3xl">
                    {formatter.format(parseInt(Math.round(props.sale.price)))} €
                  </p>
                  <p className="text-[#3E3E3E] font-bold">
                    {formatter.format(
                      parseInt(Math.round(props.sale.price_m2))
                    )}{" "}
                    €/m2
                  </p>
                </div>
                <div className="flex w-full justify-between text-sm">
                  <span className="text-[#527EDB] text-lg font-bold">
                    <p>Mínimo</p>
                    <p className="font-bold text-lg">
                      {formatter.format(
                        parseInt(Math.round(props.sale_secondary_min_price))
                      )}{" "}
                      €/m2
                    </p>
                  </span>
                  <span className="text-[#FF5B24] text-lg font-bold">
                    <p>Máximo</p>
                    <p className="font-bold text-lg">
                      {formatter.format(
                        parseInt(Math.round(props.sale_secondary_max_price))
                      )}{" "}
                      €/m2
                    </p>
                  </span>
                </div>
              </div>
              <div className="bg-white w-full px-7 py-5 rounded-lg space-y-3">
                <div>
                  <p className="text-[#3E3E3E] font-bold text-lg">
                    Precio alquiler
                  </p>
                  <p className="text-[#222222] font-bold text-3xl">
                    {formatter.format(parseInt(Math.round(props.rent.price)))} €
                  </p>
                  <p className="text-[#3E3E3E] font-bold">
                    {formatter.format(
                      parseInt(Math.round(props.rent.price_m2))
                    )}{" "}
                    €/m2
                  </p>
                </div>
                <div className="flex w-full justify-between text-sm">
                  <span className="text-[#527EDB] text-lg mr-3 font-bold">
                    <p>Mínimo</p>
                    <p className="font-bold text-lg">
                      {parseInt(Math.round(props.rent_secondary_min_price))}{" "}
                      €/m2
                    </p>
                  </span>
                  <span className="text-[#FF5B24] text-lg font-bold">
                    <p>Máximo</p>
                    <p className="font-bold text-lg">
                      {parseInt(Math.round(props.rent_secondary_max_price))}{" "}
                      €/m2
                    </p>
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-between bg-white w-full px-7 py-2 rounded-lg">
              <span className="flex items-center">
                <p className="w-full text-lg font-bold text-[#3E3E3E] mr-1">
                  Rentabilidad bruta
                </p>
              </span>
              <span className="flex">
                <p className="text-3xl font-bold text-[#222222]">
                  {(
                    ((parseFloat(props.rent.price) * 12) /
                      parseFloat(props.sale.price)) *
                    100
                  ).toFixed(1)}
                </p>
                <p className="text-xl font-bold text-[#222222]">%</p>
              </span>
            </div>
            <div className="bg-[#EEF2FB] w-full p-3 rounded-lg space-y-2">
              <span className="flex items-center">
                <Important className="h-8 w-8 mr-4" />
                <p className="w-10/12 text-lg font-bold text-[#2C2C2C]">
                  Aviso de valoración informativa
                </p>
              </span>
              <p className="text-[#656565] text-sm leading-[1.1]">
                La valoración proporcionada es una estimación aproximada basada
                en datos públicos de anuncios y transacciones inmobiliarias
                similares. No constituye una tasación oficial ni tiene validez
                legal. Para una evaluación precisa, se recomienda realizar una
                tasación profesional que considere las características
                específicas de la propiedad. Esta valoración es informativa y no
                debe ser utilizada como base para decisiones financieras o
                legales.
              </p>
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default Module1;
